import Toast from './Toast';

export type { TypeToastProps } from './types';
export default Toast;
